import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import useLoginInfo from "./useLoginInfo";
import * as walletAction from "store/entities/wallet/action";
import { toast } from "react-toastify";


const useWallet = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const {userInfo} = useLoginInfo();
    const { walletLoading, wallet } = useSelector((s) => s.entities.wallet);


    const createWallet = () => {
        dispatch(walletAction.createWallet());
    }
    
    
    useEffect(() => {
        if (wallet?.status === "success"){
            toast.success("Wallet created successfully");
            dispatch(walletAction.getDashboardSilent(userInfo.token));
            dispatch(walletAction.createWalletReset());
            history.push("/wallet");
        }
        // eslint-disable-next-line
    }, [wallet])

    
    return { walletLoading, wallet, createWallet };
}


export default useWallet;
